import { render, staticRenderFns } from "./plot-info.vue?vue&type=template&id=b01c2572&"
import script from "./plot-info.vue?vue&type=script&lang=js&"
export * from "./plot-info.vue?vue&type=script&lang=js&"
import style0 from "./plot-info.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports